import clsx from 'clsx';
import React from 'react';

export type BadgeColor = 'yellow' | 'gray' | 'green' | 'red' | 'gray-white';

interface Props {
  color: BadgeColor;
  className?: string;
  children: React.ReactNode;
}

function getColorClass(color: BadgeColor): string {
  switch (color) {
    case 'gray':
      return 'bg-gray-100 text-gray-800';
    case 'gray-white':
      return 'bg-gray-300 text-white';
    case 'yellow':
      return 'bg-yellow-100 text-yellow-800';
    case 'green':
      return 'bg-green-100 text-green-800';
    case 'red':
      return 'bg-red-100 text-red-800';
    default:
      throw new Error(`Unknown badge color ${color as string}`);
  }
}

function Badge({ color, className, children }: Props): JSX.Element {
  return (
    <span
      className={clsx(
        'inline-flex h-fit w-fit items-center rounded-full px-3 py-0.5 text-sm font-medium',
        getColorClass(color),
        className,
      )}
    >
      {children}
    </span>
  );
}

export default Badge;
